import { useState, useEffect } from 'react';
import { Box, Input, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { SearchOutlineIcon, CloseIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { useDebounce } from 'Helper/debounce';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const SearchComponent = ({
  value,
  isDisabled,
  isClearable = true,
  helpText,
  leftIcon: LeftIcon = () => <SearchOutlineIcon size="14px" />,
  rightIcon: RightIcon,
  onSearch,
  maxWidth = 'unset',
  width = 'unset',
  height = '34px',
  debounceTime = 300,
}) => {
  const [localValue, setLocalValue] = useState(value || '');
  const [isNextLoad, setIsNextLoad] = useState(false);
  const { t } = useTranslation('common')
  
  const debounceTimes = isNextLoad ? 1000 : debounceTime;
  const debouncedSearch = useDebounce((props) => {
    onSearch(props);
    setIsNextLoad(Boolean(props.length));
  }, debounceTimes);

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e) => {
    const { value } = e.target;
    setLocalValue(value);
    if (value?.length > 2 || !value?.length) {
      debouncedSearch(value);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch?.(localValue);
    }
  };

  const handleClear = () => {
    setLocalValue('');
    setIsNextLoad(false);
    onSearch?.('');
  };

  return (
    <Box
      className={`${styles['search-component__container']} ${isDisabled && styles['search-component__container--disabled']}`}
      maxWidth={maxWidth}
      width={width}
    >
      <Box position="relative">
        <Box className={styles['search-icon__container']} onClick={() => onSearch?.(localValue)}>
          <LeftIcon />
        </Box>

        <Input
          value={localValue}
          onKeyDown={handleKeyPress}
          onChange={handleChange}
          className={styles['search-input']}
          placeholder={t('search')}
          disabled={isDisabled}
          focusBorderColor="transparent"
          autoComplete="off"
          background="white"
          type="text"
          height={height}
        />

        <Condition statement={isClearable && localValue}>
          <IconButton icon={<CloseIcon />} size="sm" variant="ghost" className={styles['clear-button']} onClick={handleClear} aria-label="Clear search" />
        </Condition>

        <Condition statement={RightIcon && !localValue}>
          <Box className={styles['right-icon__container']}>
            <RightIcon />
          </Box>
        </Condition>
      </Box>

      <Condition statement={helpText}>
        <TextRegular className={styles['help-text']}>{helpText}</TextRegular>
      </Condition>
    </Box>
  );
};

export default SearchComponent;
